export const SEARCHING = 'SEARCHING';
export const SEARCHING_SUCCESS = 'SEARCHING_SUCCESS';
export const SEARCHING_FAILURE = 'SEARCHING_FAILURE';
